import { Helmet } from 'react-helmet-async';

const SEO = ({ theme = 'light' }) => {
  const siteUrl    = 'https://usamasajid.com';
  const ogImage    = `${siteUrl}/og-image.png`;
  const title      = 'Usama Sajid | Frontend Engineer';
  const description = 'Usama Sajid is a Frontend Engineer creating responsive, accessible, high-performance web interfaces and polished digital experiences. Based in Dubai, UAE. 5+ years experience, 20+ projects delivered.';

  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Usama Sajid',
    url: siteUrl,
    image: ogImage,
    jobTitle: 'Frontend Engineer',
    description,
    email: 'usamasajid8@gmail.com',
    telephone: '+971529729709',
    worksFor: {
      '@type': 'Organization',
      name: 'Binghatti Development L.L.C',
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Dubai',
      addressCountry: 'AE',
    },
    knowsAbout: ['Frontend Engineering', 'UI Engineering', 'Responsive Web Design', 'Accessibility', 'Web Performance', 'Interaction Design', 'Design Implementation'],
    sameAs: [
      'https://www.linkedin.com/in/usama-sajid-dev',
      'https://www.facebook.com/usama.sajid.4862',
      'https://www.instagram.com/usamasajid4',
    ],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Usama Sajid Portfolio',
    url: siteUrl,
    description,
    author: { '@type': 'Person', name: 'Usama Sajid' },
  };

  return (
    <Helmet>
      {/* ── Primary ── */}
      <html lang="en" />
      <title>{title}</title>
      <meta name="description"        content={description} />
      <meta name="keywords"           content="Usama Sajid, Frontend Engineer, Frontend Developer, Dubai, UI Engineer, Web Interface Developer, Responsive Web Design, Accessibility, Web Performance, UAE" />
      <meta name="author"             content="Usama Sajid" />
      <meta name="robots"             content="index, follow, max-snippet:-1, max-image-preview:large" />
      <meta name="theme-color"        content={theme === 'dark' ? '#11130F' : '#F7F7F4'} />
      <link rel="canonical"           href={siteUrl} />

      {/* ── Open Graph ── */}
      <meta property="og:type"        content="website" />
      <meta property="og:url"         content={siteUrl} />
      <meta property="og:title"       content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image"       content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height"content="630" />
      <meta property="og:locale"      content="en_US" />
      <meta property="og:site_name"   content="Usama Sajid Portfolio" />

      {/* ── Twitter Card ── */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image"       content={ogImage} />

      {/* ── JSON-LD Structured Data ── */}
      <script type="application/ld+json">{JSON.stringify(personSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
    </Helmet>
  );
};

export default SEO;
